var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommonIconHome(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.5L3.33333 7.16667M3.33333 7.16667L8 2.5L12.6667 7.16667M3.33333 7.16667V13.8333C3.33333 14.0101 3.40357 14.1797 3.5286 14.3047C3.65362 14.4298 3.82319 14.5 4 14.5H6M12.6667 7.16667L14 8.5M12.6667 7.16667V13.8333C12.6667 14.0101 12.5964 14.1797 12.4714 14.3047C12.3464 14.4298 12.1768 14.5 12 14.5H10M6 14.5C6.17681 14.5 6.34638 14.4298 6.4714 14.3047C6.59643 14.1797 6.66667 14.0101 6.66667 13.8333V11.1667C6.66667 10.9899 6.7369 10.8203 6.86193 10.6953C6.98695 10.5702 7.15652 10.5 7.33333 10.5H8.66667C8.84348 10.5 9.01305 10.5702 9.13807 10.6953C9.2631 10.8203 9.33333 10.9899 9.33333 11.1667V13.8333C9.33333 14.0101 9.40357 14.1797 9.5286 14.3047C9.65362 14.4298 9.82319 14.5 10 14.5M6 14.5H10",
    stroke: "#6B7280",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIconHome);
export default __webpack_public_path__ + "static/media/common_icon_home.a98ab0dfb81d797d64b499626d8e5176.svg";
export { ForwardRef as ReactComponent };